import { EquipmentTag } from "@prisma/client";
import { z } from "zod";

export const createEquipmentSchema = z.object({
  name: z.string(),
  quantity: z.coerce.number().min(0),
  description: z.string().nullable(),
  tags: z.array(z.nativeEnum(EquipmentTag)),
});

export const defaultCreateEquipmentValues: CreateEquipmentForm = {
  name: "",
  quantity: 0,
  description: "",
  tags: [],
};

export type CreateEquipmentForm = z.infer<typeof createEquipmentSchema>;
